import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhoneVolume,
} from "@fortawesome/free-solid-svg-icons";

const ContactUs = () => (
  <section id="contactus" className="util__section contactus__root">
    <div className="util__container">
      <h2 className="contactus__title">Contactez-nous !</h2>
      <p className="contactus__description">
        Besoin d'en savoir plus sur comment ça marche ?
        <br />
        Nous serons ravis de répondre à toutes vos questions.
      </p>
      <div className="contactus__info-grid">
        <div className="contactus__info-item">
          <FontAwesomeIcon icon={faEnvelope} className="contactus__icon" />
          <a href="mailto:contact@carteverte.co">contact@carteverte.co</a>
        </div>
        <div className="contactus__info-item">
          <FontAwesomeIcon icon={faPhoneVolume} className="contactus__icon" />
          <a href="tel:003361284008">00 33 6 17 28 40 08</a>
        </div>
      </div>
    </div>
  </section>
);

export default ContactUs;
